import React, { useState } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

const footerGroups = [
  {
    id: "care",
    title: "Customer care",
    links: [
      { label: "Contact", to: "/contact" },
      { label: "Shipping", to: "/shipping" },
      { label: "Returns", to: "/returns" },
      { label: "Privacy", to: "/privacy" },
    ],
  },
  {
    id: "information",
    title: "Information",
    links: [
      { label: "Our story", to: "/about" },
      { label: "Shop all", to: "/shop" },
      { label: "Terms", to: "/terms" },
    ],
  },
  {
    id: "explore",
    title: "Resources",
    links: [
      { label: "New arrivals", to: "/shop?tag=new" },
      { label: "For kids", to: "/shop?tag=kids" },
      { label: "Your cart", to: "/cartpage" },
    ],
  },
];

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Footer() {
  const [email, setEmail] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState("idle");
  const [openGroups, setOpenGroups] = useState({});
  const brandName = siteConfig?.brandName || "Paperie";
  const contact = siteConfig?.contact || {};

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    if (!emailPattern.test(email.trim())) {
      setNewsletterStatus("error");
      return;
    }
    setNewsletterStatus("success");
    setEmail("");
  };

  const toggleGroup = (groupId) => {
    setOpenGroups((current) => ({
      ...current,
      [groupId]: !current[groupId],
    }));
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-brand-column">
          <Link className="footer-brand" to="/" onClick={toTop}>
            <span aria-hidden="true">
              {siteConfig.logo?.image ? (
                <img src={siteConfig.logo.image} alt="" />
              ) : (
                "✣"
              )}
            </span>
            {siteConfig.logo?.text || brandName}
          </Link>
          <p>{contact.address || "A little paper studio"}</p>
          {contact.email && <a href={`mailto:${contact.email}`}>{contact.email}</a>}
        </div>

        <nav className="footer-groups" aria-label="Footer">
          {footerGroups.map((group) => {
            const isOpen = Boolean(openGroups[group.id]);
            return (
              <section className="footer-link-group" key={group.id}>
                <button
                  className="footer-link-group__toggle"
                  type="button"
                  aria-controls={`footer-links-${group.id}`}
                  aria-expanded={isOpen}
                  onClick={() => toggleGroup(group.id)}
                >
                  <span>{group.title}</span>
                  <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
                </button>
                <h2>{group.title}</h2>
                <div
                  className={`footer-link-group__links ${
                    isOpen ? "is-open" : ""
                  }`}
                  id={`footer-links-${group.id}`}
                >
                  {group.links.map((link) => (
                    <Link key={link.label} to={link.to} onClick={toTop}>
                      {link.label}
                    </Link>
                  ))}
                </div>
              </section>
            );
          })}
        </nav>

        <section className="footer-newsletter" aria-labelledby="newsletter-title">
          <div className="footer-social" aria-label="Social channels">
            <span>Instagram</span>
            <span>Pinterest</span>
            <span>Facebook</span>
          </div>
          <h2 id="newsletter-title">Join the list for offers + goodies!</h2>
          <form
            className={`footer-newsletter__form footer-newsletter__form--${newsletterStatus}`}
            noValidate
            onSubmit={handleNewsletterSubmit}
          >
            <label htmlFor="newsletter-email">Your email address</label>
            <div>
              <input
                id="newsletter-email"
                type="email"
                value={email}
                inputMode="email"
                autoComplete="email"
                placeholder="YOUR EMAIL ADDRESS"
                aria-invalid={newsletterStatus === "error"}
                aria-describedby="newsletter-message"
                onChange={(event) => {
                  setEmail(event.target.value);
                  setNewsletterStatus("idle");
                }}
              />
              <button type="submit" aria-label="Join the newsletter">
                →
              </button>
            </div>
            <p id="newsletter-message" aria-live="polite">
              {newsletterStatus === "error" &&
                "Please enter a valid email address."}
              {newsletterStatus === "success" && "Welcome to the paper party!"}
            </p>
          </form>
        </section>
      </div>

      <div className="footer-bottom">
        <p>
          <span className="footer-bottom__script">Made with joy</span>{" "}
          © {new Date().getFullYear()} {brandName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
